import { CreateRenderFunction } from "@pdfking/reactivity/preact"

import { InputMixin } from "../mixins/InputMixin"
import { input_class } from "./classes"

export const DjTextarea = CreateRenderFunction({
  mixins: [InputMixin] as const,
  props: {
    error: undefined as unknown,
    input: "",
    oncommit: undefined as ((v: string) => void) | undefined,
  },
  render() {
    return (
      <textarea
        className={`${input_class(this.error)} h-16`}
        disabled={this.disabled}
        id={this.dom_id}
        onBlur={(e: Event) => this.oncommit?.((e.target as HTMLTextAreaElement).value)}
        value={String(this.input ?? "")}
      />
    )
  },
})
